<template>
  <form @submit="requestAccess" class="row" method="get" target="ajax">
    <div class="col-xs-12 xlarge-text">
      <p><b>{{ _('Please note that our offers and services apply exclusively for enterprises. ') }}</b></p>
    </div>
    <div class="col-xs-12">
      <input v-model="is_customer" id="is_new_customer" type="checkbox" name="save-password">
      <label for="is_new_customer" class="large-text">
        <span class="glyphicon glyphicon-check"></span>
        <span class="glyphicon glyphicon-unchecked"></span>
        {{ _('I\'m already a registered customer') }}
      </label>

    </div>
    <div class="col-xs-12 col-sm-6">
      <input type="text" v-model="company" name="company" :placeholder="_('Company')+' *'" class="xlarge-text"
             required="required">
    </div>
    <div class="col-xs-12 col-sm-6">
      <input type="email" name="email" v-model="email"
             :placeholder="_('Email')+' *'"
             class="xlarge-text" required="required">
    </div>
    <div class="col-xs-12 col-sm-6">
      <input type="text" name="name" v-model="name" :placeholder="_('Name')+' *'" class="xlarge-text"
             required>
    </div>
    <div class="col-xs-12 col-sm-6">
      <input type="text" name="first_name" v-model="first_name" :placeholder="_('First name')+' *'"
             class="xlarge-text"
             required>
    </div>

    <div class="col-xs-12" v-if="!is_customer">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <input type="text" name="street" v-model="street" :placeholder="_('Street / number')+' *'"
                 class="xlarge-text"
                 required>
        </div>
        <div class="col-xs-12 col-sm-6">
          <input type="text" name="city" v-model="city" :placeholder="_('Postcode / place')+' *'"
                 class="xlarge-text"
                 required>
        </div>
        <div class="col-xs-12 col-sm-6">
          <!--					<input type="text" v-model="country" :placeholder="_('Country')" class="xlarge-text" required>-->
          <select name="country" v-model="country" :placeholder="_('Country')+' *'" class="xlarge-text"
                  required>
            <option value="" selected>{{ _('Country') }}&nbsp;*</option>
            <option v-for="(name, iso) in allowed_countries" :key="iso" :value="iso">{{ _(name) }}</option>
          </select>
        </div>
        <div class="col-xs-12 col-sm-6">
          <input type="text" v-model="phone" :placeholder="_('Phone')" class="xlarge-text">
        </div>
        <div class="col-xs-12 col-sm-6">
          <input type="text" v-model="mobile" :placeholder="_('Mobile')" class="xlarge-text">
        </div>
        <div class="col-xs-12 col-sm-6">
          <input type="text" v-model="website" :placeholder="_('Website')" class="xlarge-text">
        </div>
      </div>
    </div>
    <div class="col-xs-12" v-else>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <input required="required" type="text" name="customer_number" v-model="customer_number"
                 :placeholder="_('Customer number')+' *'" minlength="4" maxlength="5" pattern=".{4,5}"
                 class="xlarge-text">
          <!--					<button type="button">-->
          <!--						<span class="glyphicon glyphicon-question-sign"></span>-->
          <!--					</button>-->
          <!--					<div class="form-group">-->
          <!--						<div class="input-group">-->
          <!--							<input type="text" name="firstname" :placeholder="_('Customer number')"-->
          <!--								   class="xlarge-text" v-tooltip="{trigger: 'focus', content: 'TEST21'}">-->
          <!--							<div class="input-group-addon">-->
          <!--								<span class=" glyphicon glyphicon-question-sign"></span>-->
          <!--							</div>-->
          <!--						</div>-->
          <!--					</div>-->
        </div>
        <div class="col-xs-12 xlarge-text">

          <!-- @formatter:off -->
					<p v-html="sprintf(_('You don’t know your customer number? Please %s, who will provide you with your Log in details as soon as possible. '), contactLink)"></p>
					<!-- @formatter:on -->
        </div>
      </div>
    </div>
    <div class="col-xs-12 xlarge-text">
      <!-- @formatter:off -->
			<p>
				<b>{{_('Registration')}}</b><br>
				{{_('To register, you will need to complete the relevant form provided on our website. We will contact you, once you have filled out all mandatory fields. All mandatory fields in the form must be completed; these are marked by an asterisk. The data is entered into an input mask and then submitted to us and saved. This data will not be forwarded to third parties. The following data is collected with this scope of the registration process:')}}
			</p>
			<ul>
				<li>{{_('The user’s IP address')}}
				<li>{{_('Date and time of registration')}}</li>
				<li>{{_('Company')}}</li>
				<li>{{_('Street / number')}}</li>
				<li>{{_('Postcode / place')}}</li>
				<li>{{_('Country')}}</li>
				<li>{{_('Name / first name')}}</li>
				<li>{{_('Mobile')}}</li>
				<li>{{_('Email')}}</li>
				<li>{{_('Website')}}</li>
			</ul>
			<p>{{_('The user’s consent for the processing of the data is obtained within the scope of the registration process. A registration of the user is required for the provision of specific contents and services. The legal basis for the processing of the data is the consent of the user as defined by Art. 6 (1) lit. a GDPR.')}}</p>
			<p><b>{{_('Cancellation policy')}}</b><br>
			<span v-html="cancelationContent"></span></p>
			<p>{{_('Additional information on data protection is available on our website at:')}} <a :href="_('https://hensel-recycling.com/en/privacy-statement/')" target="_blank" rel="noreferrer">{{_('https://hensel-recycling.com/en/privacy-statement/')}}</a> </p>


			<p><b>{{_('Please note that our offers and services apply exclusively for enterprises. ')}}</b></p>
			<!-- @formatter:on -->
    </div>
    <div class="col-xs-12">
      <button :disabled="lockSubmitButton" class="bg-light-blue xlarge-text spacer-bottom">
        <img v-if="lockSubmitButton" src="@/img/hensel-loading.svg" style="height: 1.2rem">
        <template v-else>
          {{ _('REQUEST ACCESS') }}
        </template>
      </button>
    </div>

  </form>
</template>

<script>
// import localizer from '@/mixins/localizer.js'
// import api from '../mixins/api.js'
import {mapActions} from "vuex";

export default {
  name: "AccessForm",
  // mixins: [api],
  data() {
    return {
      company: '',
      name: '',
      first_name: '',
      email: '',
      is_customer: false,
      customer_number: '',
      street: '',
      city: '',
      country: '',
      phone: '',
      mobile: '',
      website: '',
      allowed_countries: {
        "AF": "Afghanistan",
        "EG": "Ägypten",
        "AL": "Albanien",
        "DZ": "Algerien",
        "VI": "Amerikanische Jungferninsel",
        "UM": "Amerikanische Überseeinseln, kleinere",
        "AS": "Amerikanisch-Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AI": "Anguilla",
        "AG": "Antigua & Barbuda",
        "GQ": "Äquatorialguinea",
        "AR": "Argentinien",
        "AM": "Armenien",
        "AW": "Aruba",
        "AZ": "Aserbaidschan",
        "ET": "Äthiopien",
        "AU": "Australien",
        "BS": "Bahamas",
        "BH": "Bahrain",
        "BD": "Bangladesch",
        "BB": "Barbados",
        "BE": "Belgien",
        "BZ": "Belize",
        "BJ": "Benin",
        "BM": "Bermudas",
        "BT": "Bhutan",
        "BU": "Burma",
        "BO": "Bolivien",
        "BA": "Bosnien-Herzegowina",
        "BW": "Botswana",
        "BV": "Bouvetinseln",
        "BR": "Brasilien",
        "VG": "Britische Jungferninseln",
        "IO": "Britisches Territorium im Indischen Ozean",
        "BN": "Brunei",
        "BG": "Bulgarien",
        "YU": "Bundesrepublik Yugoslawien",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "CA": "Kanada",
        "CL": "Chile",
        "CN": "China",
        "CK": "Cookinseln",
        "CR": "Costa Rica",
        "DK": "Dänemark",
        "DE": "Deutschland",
        "DJ": "Dschibuti",
        "DM": "Dominica",
        "DO": "Dominikanische Republik",
        "EC": "Ecuador",
        "SV": "El Salvador",
        "CI": "Elfenbeinküste",
        "ER": "Eritrea, Republik",
        "EE": "Estland",
        "FK": "Falkland Inseln (Islas Malvinas)",
        "FO": "Färöer",
        "FJ": "Fidschi",
        "FI": "Finnland",
        "FR": "Frankreich",
        "TF": "Französische Südgebiete",
        "GF": "Französisch-Guayana",
        "PF": "Französisch-Polynesien",
        "GA": "Gabun",
        "GM": "Gambia",
        "GE": "Georgien",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GD": "Grenada",
        "GR": "Griechenland",
        "GL": "Grönland",
        "GB": "Vereinigtes Königreich Großbritannien",
        "GP": "Guadeloupe",
        "GU": "Guam",
        "GT": "Guatemala",
        "GY": "Guyana, Kooperative Republik",
        "GG": "Guernsey",
        "GN": "Guinea",
        "GW": "Guinea-Bissau",
        "HT": "Haiti",
        "HM": "Heart und McDonaldinseln",
        "HN": "Honduras",
        "HK": "Hongkong",
        "IN": "Indien",
        "ID": "Indonesien",
        "IQ": "Irak",
        "IR": "Iran",
        "IE": "Irland",
        "IS": "Island",
        "IM": "Isle of Man",
        "IL": "Israel",
        "IT": "Italien",
        "JM": "Jamaica",
        "JP": "Japan",
        "YE": "Jemen(Dem.Volksrep.)",
        "JE": "Jersey",
        "JO": "Jordanien",
        "KY": "Kaimaninseln",
        "KH": "Kambodscha",
        "CM": "Kamerun",
        "CV": "Kap Verde",
        "KZ": "Kasachstan",
        "QA": "Katar",
        "KE": "Kenia",
        "KG": "Kirgisistan",
        "KI": "Kiribati",
        "CC": "Kokosinseln",
        "CO": "Kolumbien",
        "KM": "Komoren",
        "CD": "Kongo, Demokratische Republik (ehem Zaire)",
        "ZR": "Zaire",
        "CG": "Kongo, Republik",
        "KR": "Korea Nord",
        "KP": "Korea Süd",
        "RK": "Kosovo",
        "HR": "Kroatien",
        "CU": "Kuba",
        "KW": "Kuwait",
        "LA": "Laos",
        "LS": "Lesotho",
        "LV": "Lettland",
        "LB": "Libanon",
        "LR": "Liberia",
        "LY": "Libyen",
        "LI": "Liechtenstein",
        "LT": "Litauen",
        "LU": "Luxemburg",
        "MO": "Macau (Aomen)",
        "MG": "Madagaskar",
        "MW": "Malawi",
        "MY": "Malaysia",
        "MV": "Malediven",
        "ML": "Mali",
        "MT": "Malta",
        "MA": "Marokko",
        "MH": "Marshallinseln, Republik der",
        "MQ": "Martinique",
        "MR": "Mauretanien",
        "MU": "Mauritius",
        "YT": "Mayotte",
        "MK": "Mazedonien (ehem jugoslawische Republik)",
        "MX": "Mexico",
        "FM": "Mikronesien, Föderierte Staaten von",
        "MZ": "Mocambique",
        "MC": "Monaco",
        "MN": "Mongolei",
        "MS": "Montserrat",
        "MD": "Republik, Moldau",
        "MM": "Myanmar (ehem Birma / Burma)",
        "NA": "Namibia",
        "NR": "Nauru",
        "NP": "Nepal",
        "NC": "Neukaledonien",
        "NZ": "Neuseeland",
        "NI": "Nicaragua",
        "NL": "Niederlande",
        "AN": "Niederländische Antillen",
        "NE": "Niger",
        "NG": "Nigeria",
        "NU": "Niueinseln",
        "MP": "Nördliche Marianen, Commenwealth der",
        "NF": "Norfolkinseln",
        "NO": "Norwegen",
        "OM": "Oman",
        "AT": "Österreich",
        "TP": "Osttimor",
        "PK": "Pakistan",
        "PS": "Palästina",
        "PW": "Palau, Republik",
        "PA": "Panama",
        "PG": "Papua Neuguinea",
        "PY": "Paraguay",
        "PE": "Peru",
        "PH": "Philippinen",
        "PN": "Pitcairninseln",
        "PL": "Polen",
        "PT": "Portugal",
        "PR": "Puerto Rico",
        "ME": "Republik Montenegro",
        "RS": "Republik Serbien",
        "RW": "Ruanda",
        "RO": "Rumänien",
        "RU": "Russland",
        "KN": "St. Kitts und Nevis (ehem St. Christopher und Nevis) ",
        "LC": "St. Lucia",
        "VC": "St. Vincent und die Grenadinen",
        "SB": "Salomonen",
        "ZM": "Sambia",
        "WS": "West Samoa",
        "SM": "St. Marino",
        "ST": "Sao Tome & Principe",
        "SA": "Somalia",
        "SE": "Schweden",
        "CH": "Schweiz",
        "SN": "Senegal",
        "SC": "Seychellen",
        "SL": "Sierra Leone",
        "ZW": "Zimbabwe",
        "SG": "Singapur",
        "SK": "Slowakische Republik",
        "SI": "Slowenien",
        "ES": "Spanien",
        "LK": "Sri Lanka",
        "SH": "St. Helena",
        "PM": "St. Pierre und Miquelon",
        "ZA": "Südafrika",
        "SD": "Sudan",
        "GS": "Südgeorgien und die Sandwichinseln",
        "SR": "Surinam",
        "SZ": "Swasiland",
        "SY": "Syrien",
        "TJ": "Tadschikistan",
        "null": "Tahiti",
        "TW": "Taiwan",
        "TZ": "Tansania",
        "TH": "Thailand",
        "TG": "Togo",
        "TK": "Tokelau",
        "TO": "Tonga",
        "TT": "Trinidad & Tobago",
        "TD": "Tschad",
        "CZ": "Tschechien",
        "TN": "Tunesien",
        "TR": "Türkei",
        "TM": "Turkmenistan",
        "TC": "Turks- und Caicosinseln",
        "TV": "Tuvalu",
        "UG": "Uganda",
        "UA": "Ukraine",
        "HU": "Ungarn",
        "UY": "Uruguay",
        "UZ": "Usbekistan",
        "VU": "Vanuatu",
        "VA": "Vatikanstaat",
        "VE": "Venezuela",
        "AE": "Verein. Arabische Emirate",
        "US": "Vereinigte Staaten von Amerika",
        "VN": "Vietnam",
        "WF": "Wallis und Futuna",
        "CX": "Weihnachtsinseln",
        "BY": "Weißrußland (Belarus)",
        "CF": "Zentralafrika",
        "CY": "Zypern"
      },
      lockSubmitButton: false
    }
  },
  computed: {
    contactLink() {
      return '<a href="https://hensel-recycling.com/kontakt/" target="_blank" rel="noreferrer">' + this._('contact your account manager') + '</a>'
    },
    cancelationContent() {
      return this._('The user has the right to inspect their own personal data stored by Hensel Recycling and the settings of his user profile at Hensel Recycling and where applicable request the rectification, addition and erasure of such data – in all cases with future effect. Consent to these general terms of use can be withdrawn by the user at any time either by written correspondence or email to %s.').replace('%s', ['<', 'a target="_blank" rel="noreferrer" href="mailto:', this._('datenschutz@hensel-recycling.com'), '">', this._('datenschutz@hensel-recycling.com'), '<', '/a>'].join(''))
    }
  },
  methods: {
    ...mapActions({
      sendAccessRequest: 'Api/Users/request_access'
    }),
    requestAccess(e) {
      e.preventDefault();

      if (this.lockSubmitButton) {
        return
      }

      if (this.isFormValid()) {
        this.lockSubmitButton = true;
        let params = {
          customer_type: this.is_customer ? "existing" : "new"
        };
        Object.assign(params, this.$data);

        this.sendAccessRequest(params)
            .then(result => {
              this.$store.commit('setLatestError', {
                code: '',
                message: this._('Thank You for your request. We will contact You as soon as possible.'),
                hidden: false
              });

              // hide access form
              this.$store.commit('hideAccessForm', true)

              //if webversion start 30min timer to unlock the form
              if (this.$config.IS_WEB_VERSION) {
                setTimeout(() => this.$store.commit('hideAccessForm', false), 1800000);
              }
            })
            .catch(this.apiErrorHandler)
            .finally(() => this.lockSubmitButton = false)
      } else {
        this.$store.commit('setLatestError', {
          code: '',
          message: this._('Invalid Form. Please fill out all required fields.'),
          hidden: false
        })
      }

    },
    requiredCheck(name) {
      let element = document.getElementsByName(name)[0];
      if (!element) {
        return false;
      }
      if (!this[name]) {
        element.setCustomValidity("Field is required!");
        element.classList.add('invalid');
        return false;
      } else {
        element.setCustomValidity("");
        element.classList.remove('invalid');
        return true;
      }
    },
    isFormValid() {
      let isValid = true;

      ['company', 'email', 'name', 'first_name'].forEach((el) => {
        isValid = this.requiredCheck(el) ? isValid : false;
      });

      if (this.is_customer) {
        isValid = this.requiredCheck('customer_number') ? isValid : false;
      } else {
        ['street', 'city', 'country'].forEach((el) => {
          isValid = this.requiredCheck(el) ? isValid : false;
        });
      }
      return isValid;
    }
  }
}
</script>
